module.exports = __webpack_public_path__ + "img/topUp.9b3ca2b5.svg";